import { Injectable } from '@angular/core';

@Injectable()
export class SpinnerService {

  private _spinner: boolean;

  constructor() { }

  public get spinner() {
    return this._spinner;
  }

  public showSpinner() {
    this._spinner = true;
  }

  public hideSpinner() {
    this._spinner = false;
  }

}
